import type DefaultShiftForm from 'modules/shift_management/lib/forms/DefaultShiftForm'
import type UnassignedShiftForm from 'modules/shift_management/lib/forms/UnassignedShiftForm'

interface FormDataReturnProps {
  teamsIdsVisibilities: number[]
  locationsIdsVisibilities: number[]
}

interface Props {
  form: DefaultShiftForm | UnassignedShiftForm
  isSingleSelector: boolean
}

const buildShiftsVisibility = ({ form, isSingleSelector }: Props): FormDataReturnProps => {
  if (form.get('all_company').value)
    return {
      teamsIdsVisibilities: [],
      locationsIdsVisibilities: [],
    }

  const teamsIdsValue = form.get('teams_ids_visibilities').value
  const locationsIdsValue = form.get('locations_ids_visibilities').value

  const teamsIdsVisibilities = !teamsIdsValue
    ? []
    : isSingleSelector
      ? [Number(teamsIdsValue)]
      : teamsIdsValue

  const locationsIdsVisibilities = !locationsIdsValue
    ? []
    : isSingleSelector
      ? [Number(locationsIdsValue)]
      : locationsIdsValue

  return {
    teamsIdsVisibilities,
    locationsIdsVisibilities,
  }
}

export default buildShiftsVisibility
